export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const UPDATE_USER_AUTH_REQUEST = "UPDATE_USER_AUTH_REQUEST";
export const UPDATE_USER_AUTH_SUCCESS = "UPDATE_USER_AUTH_SUCCESS";
export const UPDATE_USER_AUTH_FAIL = "UPDATE_USER_AUTH_FAIL";

// For getting one user data
export const GET_ONE_USER_REQUEST = "GET_ONE_USER_REQUEST";
export const GET_ONE_USER_SUCCESS = "GET_ONE_USER_SUCCESS";
export const GET_ONE_USER_FAIL = "GET_ONE_USER_FAIL";

// For getting one user's auth data
export const GET_ONE_USER_AUTH_REQUEST = "GET_ONE_USER_AUTH_REQUEST";
export const GET_ONE_USER_AUTH_SUCCESS = "GET_ONE_USER_AUTH_SUCCESS";
export const GET_ONE_USER_AUTH_FAIL = "GET_ONE_USER_AUTH_FAIL";

// For getting all user data
export const GET_ALL_USER_REQUEST = "GET_ALL_USER_REQUEST";
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS";
export const GET_ALL_USER_FAIL = "GET_ALL_USER_FAIL";

// For  user status change  data
export const UPDATE_USER_STATUS_REQUEST = "UPDATE_USER_STATUS_REQUEST";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_FAIL = "UPDATE_USER_STATUS_FAIL";
